const OpenLink = {
  install: (Vue) => {
    Vue.component('ChatOpenLink', () => {
      return import('./components/index.vue')
    })
  }
}

export default OpenLink
